import { AsyncPipe, DecimalPipe } from '@angular/common';
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { IconComponent, ModalComponent, SwitchComponent, ToggleSwitchComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'saving-plans-dynamization',
  imports: [AsyncPipe, TranslocoPipe, SwitchComponent, IconComponent, ToggleSwitchComponent, DecimalPipe, ModalComponent],
  templateUrl: './savings-plan-dynamization.component.html',
})
export class SavingsPlanDynamizationComponent {
  @ViewChild('dynamizationInfo', { static: true }) private readonly _content: ElementRef;

  public readonly facade = inject(SavingsPlanFacade);
  readonly #ngbModal = inject(NgbModal);

  public openDynamizationInfo = () => this.#ngbModal.open(this._content, { size: 'md' });
}
